import { useState } from 'react';

function useScrollPosition<T extends string>(keys: T[]) {
  const [scrollPositionMap, setScrollPositionMap] = useState<Record<T, number>>(() =>
    keys.reduce(
      (acc, key) => ({
        ...acc,
        [key]: 0,
      }),
      {} as Record<T, number>,
    ),
  );

  const saveScrollPosition = (key: T) => {
    const currentScrollPosition = window.scrollY;
    setScrollPositionMap((prev) => ({
      ...prev,
      [key]: currentScrollPosition,
    }));
  };

  const restoreScrollPosition = (key: T) => {
    requestAnimationFrame(() => {
      window.scrollTo({
        top: scrollPositionMap[key],
      });
    });
  };

  return {
    saveScrollPosition,
    restoreScrollPosition,
  };
}

export default useScrollPosition;
